import duotoneGradientHapes from "../../zHapeStorage/duotoneGradientHapes"
import gradients from "../../zHapeStorage/gradientsFromGradientHapes"
import { itemNames } from "../enum/constants"
import { isFullBodyContract } from "../../src/abis/constants";


export const getHapeGradient = card => {
	let linearGradient
	let gradientValue = getHapeGradientHelper(card)
	// console.log("getHapeGradient gradientValue", gradientValue)

	const gradient = gradientValue?.horizontal

	linearGradient = `linear-gradient(${"315deg"},${gradient?.coord_1}, ${
		gradient?.coord_2
	}, ${getLighterShade(gradient?.coord_3)})`
	return linearGradient
}

const getLighterShade = colorValue => {
	// console.log("getLighterShade colorValue", colorValue)
	if (typeof colorValue !== "string" || !colorValue.includes("(")) {
		return "rgba(0,0,0,.4)"
	}
	const rgbaArray = colorValue
		.substring(colorValue.indexOf("(") + 1, colorValue.indexOf(")"))
		.split(",")

	const finalRgba = `rgba(${rgbaArray[0]}, ${rgbaArray[1]}, ${rgbaArray[2]}, .4)`

	return finalRgba
}

export const getHapeGradientHelper = card => {
	// console.log("getHapeGradientHelper card", card)
	const ignoreDuotone = []
	const DUOTONE_CATEGORY = "duotone"
	const FUR_CATEGORY = "Fur"

	const DEFAULT_CATEGORY = "Default"

	const cardTokenId = parseInt(card?.token_id)
	const traits = Array.isArray(card?.traits) ? card.traits : []
	traits.forEach(trait => {
		if (!trait || typeof trait !== "object") return
		if (trait.drop && trait.drop.drop_type && trait.drop.drop_type.parent) {
			trait.category = trait.drop.drop_type.parent.name
		} else if (trait.drop && trait.drop.drop_type) {
			trait.category = trait.drop.drop_type.name
		}
	})
	// Function to find a trait by category
	// console.log("getHapeGradientHelper card.traits", cardTokenId,card.traits)
	const findTraitByCategory = (list, category) =>
		list.find(
			trait =>
				typeof trait?.category === "string" &&
				trait.category.toLowerCase() === category.toLowerCase()
		)

	// Check if the card has a duotone trait and is not ignored
	const isDuotone =
		findTraitByCategory(traits, DUOTONE_CATEGORY) &&
		!ignoreDuotone.includes(cardTokenId)

	// console.log("getHapeGradientHelper isDuotone", isDuotone)

	let gradientValue

	if (isDuotone) {
		// If duotone, try to find the specific gradient for the card by token_id
		const duotoneGradient = duotoneGradientHapes.find(
			h => h.token_id === cardTokenId
		)?.gradient
		// console.log("getHapeGradientHelper duotoneGradient", duotoneGradient)
		if (duotoneGradient) {
			gradientValue = duotoneGradient
		}
	}

	// console.log("getHapeGradientHelper gradientValue", gradientValue)

	if (!gradientValue) {
		// If not duotone or no specific duotone gradient found, default to finding a gradient by the Fur trait
		const furTrait = findTraitByCategory(traits, FUR_CATEGORY)
		if (furTrait) {
			// console.log("getHapeGradientHelper furTrait", furTrait)
			const furGradient = gradients.find(
				h => h.fur === furTrait.value
			)?.gradient
			gradientValue = furGradient
		}
	}

	if (!gradientValue) {
		const defaultGradient = gradients.find(
			h => h.fur === DEFAULT_CATEGORY
		)?.gradient
		gradientValue = defaultGradient
	}

	// console.log("getHapeGradientHelper gradientValue", gradientValue)

	return gradientValue
}

// export const getHapeGradientHelper = card => {
// 	const ignoreDuotone = []
// 	const isDuotone = card.traits.find(
// 		t => t.category.toLowerCase() === "duotone"
// 	)
// 	let gradientValue

// 	if (isDuotone && !ignoreDuotone.includes(card.token_id)) {
// 		gradientValue = duotoneGradientHapes.find(
// 			h => h.token_id === card.token_id
// 		)?.gradient
// 	} else {
// 		gradientValue = gradients.find(
// 			h => h.fur === card.traits.find(t => t.category === "Fur").value
// 		).gradient
// 	}

// 	return gradientValue
// }

export const getHapeImageUrl = async (hape, imageDimensions) => {
	// return hape.image
	// if (hape.no_backgroud_image && hape.no_backgroud_image.length > 0 && typeof hape.no_backgroud_image === 'string') {
	// 	return hape.no_backgroud_image
	// }

	console.log("getHapeImageUrl hape.traits", hape.traits)
	let attributes: { trait_type: string; value: string; image_url?: string }[] = []
	for (const trait of hape.traits) {
		let rarity_type = "common"
		if (trait.drop && trait.drop.attributes && Array.isArray(trait.drop.attributes)) {
			trait.drop.attributes.forEach((attribute: any) => {
				if (attribute.trait_type === "Rarity") {
					rarity_type = attribute.value
				}
			})
		}
		
		let category = ""
		if (trait.drop && trait.drop.drop_type) {
			if (trait.drop.drop_type.parent && trait.drop.drop_type.parent.name) {
				category = trait.drop.drop_type.parent.name
			} else if (trait.drop.drop_type.name) {
				category = trait.drop.drop_type.name
			}
		}

		// console.log("rarity_type", rarity_type)
		// console.log("category", category)
		let attribute: { trait_type: string; value: string; image_url?: string } = {
			trait_type: category,
			value: trait.drop && trait.drop.name || "",
		}
		// if (trait.drop && trait.drop.image && trait.drop.image.length > 0 && typeof trait.drop.image === 'string') {
		// 	attribute.image_url = trait.drop.image
		// }
		attributes.push(attribute)
	}

	const url = process.env.NEXT_PUBLIC_API_BASE_URL + "/frontend/api/v1/hape/generator/equipped/image"
	let hape_id_param = hape.token_id
	if (hape.token_id && typeof hape.token_id === 'string') {
		hape_id_param = parseInt(hape.token_id)
	}
	const body: {
		fmt: string
		attributes: any[]
		include_background: boolean
		hape_id: number
		hape_uuid: string
		is_full_body?: boolean
	} = {
		fmt: "png",
		attributes: attributes,
		include_background: false,
		hape_id: hape_id_param,
		hape_uuid: hape.id,
	}
	if (isFullBodyContract(hape.contract_address)) {
		body.is_full_body = true
	}

	const response = await fetch(
		url,
		{
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Content-Type": "application/json",
			},
		},
	)

	let data = await response.json()
	// console.log("getHapeImageUrl data", data)
	if (data.code === 200) {
		return data.data.image
	}
	return null
}

export const getOriginalHapeImageUrl = (hape,tokenId, imageDimensions) => {
	return hape.image
	// console.log("getOriginalHapeImageUrl tokenId", tokenId)
	// console.log("getOriginalHapeImageUrl imageDimensions", imageDimensions)
	// return `https://d2txl75rmr4hou.cloudfront.net/fit-in/${imageDimensions}x${imageDimensions}/${tokenId}.png`
}
